import apiClient from '../client';
import type { FeeLedgerEntry, FeeLedgerStudentDetail, FinanceDashboardData } from '@/types';

export const feeLedgerApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: FeeLedgerEntry[]; pagination: { total: number } }>('/admin/fee-ledger', { params }).then((r) => r.data),

  getStudentDetail: (admissionId: number, params?: Record<string, unknown>) =>
    apiClient.get<{ data: FeeLedgerStudentDetail }>(`/admin/fee-ledger/${admissionId}`, { params }).then((r) => r.data.data),

  getHistory: (admissionId: number) =>
    apiClient.get<{ data: FeeLedgerEntry[] }>(`/admin/fee-ledger/${admissionId}/history`).then((r) => r.data.data),

  getInvoices: (admissionId: number, params?: Record<string, unknown>) =>
    apiClient.get<{ data: unknown[] }>(`/admin/fee-ledger/${admissionId}/invoices`, { params }).then((r) => r.data.data),

  recalculate: (admissionNo: string, params?: Record<string, unknown>) =>
    apiClient.post<{ data: unknown }>(`/admin/fee-ledger/recalculate/${admissionNo}`, null, { params }).then((r) => r.data.data),
};

export const financeDashboardApi = {
  getDashboard: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: FinanceDashboardData }>('/admin/finance/dashboard', { params }).then((r) => r.data.data),
};
